var map = {
	"./af-ZA.po": "../locale/af-ZA.po",
	"./bg-BG.po": "../locale/bg-BG.po",
	"./cs-CZ.po": "../locale/cs-CZ.po",
	"./da-DK.po": "../locale/da-DK.po",
	"./de-DE.po": "../locale/de-DE.po",
	"./en-GB.po": "../locale/en-GB.po",
	"./en-US.po": "../locale/en-US.po",
	"./es-ES.po": "../locale/es-ES.po",
	"./fr-FR.po": "../locale/fr-FR.po",
	"./hr-HR.po": "../locale/hr-HR.po",
	"./id-ID.po": "../locale/id-ID.po",
	"./it-IT.po": "../locale/it-IT.po",
	"./ja-JP.po": "../locale/ja-JP.po",
	"./ko-KR.po": "../locale/ko-KR.po",
	"./pl-PL.po": "../locale/pl-PL.po",
	"./pt-BR.po": "../locale/pt-BR.po",
	"./pt-PT.po": "../locale/pt-PT.po",
	"./ru-RU.po": "../locale/ru-RU.po",
	"./sr-SP.po": "../locale/sr-SP.po",
	"./sv-SE.po": "../locale/sv-SE.po",
	"./tr-TR.po": "../locale/tr-TR.po",
	"./uk-UA.po": "../locale/uk-UA.po",
	"./zh-CN.po": "../locale/zh-CN.po",
	"./zh-TW.po": "../locale/zh-TW.po"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../locale sync recursive ^\\.\\/.*\\.po$";